'use client';

import React, { useEffect, useRef } from 'react';
import AppImage from '@/components/ui/AppImage';

const team = [
{
  name: 'Col. Sujeet Sinha',
  role: 'President',
  image: "/assets/images/team/sujit_sinha1.png",
  alt: 'Portrait of Col. Sujeet Sinha, President of HCAF'
},
{
  name: 'Pramod Akramka',
  role: 'Finance & Accounts Secretary',
  image: "/assets/images/team/pramod_akramka.png",
  alt: 'Portrait of Pramod Akramka, Finance & Accounts Secretary at HCAF'
},
{
  name: 'Hina Ghosh',
  role: 'Convenor Finance & Accounts',
  image: "/assets/images/team/hina_ghosh.png",
  alt: 'Portrait of Hina Ghosh, Convenor Finance & Accounts at HCAF'
},
{
  name: 'Siddharth Gupta',
  role: 'HCAF Advisory Committee',
  image: "/assets/images/team/siddharth_gupta.png",
  alt: 'Portrait of Siddharth Gupta, HCAF Advisory Committee'
},
{
  name: 'Subrato Sarkaar',
  role: 'Admin Secretary',
  image: "/assets/images/team/subrato_sarkaar.png",
  alt: 'Portrait of Subrato Sarkaar, Admin Secretary at HCAF'
},
{
  name: 'Bhavya Shanbaug',
  role: 'Cultural Secretary',
  image: "/assets/images/team/bhavya_shanbaug.png",
  alt: 'Portrait of Bhavya Shanbaug, Cultural Secretary at HCAF'
},
{
  name: 'Bobita Ray',
  role: 'Puja Secretary',
  image: "/assets/images/team/bobita_ray.png",
  alt: 'Portrait of Bobita Ray, Puja Secretary at HCAF'
},
{
  name: 'Nidhi Sarkar',
  role: 'Admin Convenor & Decoration Secretary',
  image: "/assets/images/team/nidhi_sarkar.png",
  alt: 'Portrait of Nidhi Sarkar, Admin Convenor & Decoration Secretary at HCAF'
},
{
  name: 'Debangshu Choudhary',
  role: 'Infrastructure and Decoration Secretary',
  image: "/assets/images/team/debangshu.png",
  alt: 'Portrait of Debangshu Choudhary, Infrastructure and Decoration Secretary at HCAF'
},
{
  name: 'Archana Akramaka',
  role: 'Bhog Distribution Secretary',
  image: "/assets/images/team/archana_akramaka.png",
  alt: 'Portrait of Archana Akramaka, Bhog Distribution Secretary at HCAF'
},
{
  name: 'Dipti Das',
  role: 'Bhog Distribution Convenor',
  image: "/assets/images/team/dipti_das.png",
  alt: 'Portrait of Dipti Das, Bhog Distribution Convenor at HCAF'
},
{
  name: 'Prodipta Hore',
  role: 'Souvenir Committee',
  image: "/assets/images/team/prodipta_hore.png",
  alt: 'Portrait of Prodipta Hore, Souvenir Committee at HCAF'
},
{
  name: 'Nandita Hore',
  role: 'Reception Committee',
  image: "/assets/images/team/nandita_hore.png",
  alt: 'Portrait of Nandita Hore, Reception Committee at HCAF'
},
{
  name: 'Probir Das',
  role: 'Infrastructure Convenor',
  image: "/assets/images/team/probir_das.png",
  alt: 'Portrait of Probir Das, Infrastructure Convenor at HCAF'
},
{
  name: 'Parshati Chakraborty',
  role: 'Secretary Bhog & Convenor Stalls',
  image: "/assets/images/team/parshati_chakraborty.png",
  alt: 'Portrait of Parshati Chakraborty, Secretary Bhog & Convenor Stalls at HCAF'
},
{
  name: 'Suparna Biswas',
  role: 'Convenor, Cultural Committee',
  image: "/assets/images/team/suparna_biswas.png",
  alt: 'Portrait of Suparna Biswas, Convenor of the Cultural Committee at HCAF'
},
{
  name: 'Monalisa Sarkar',
  role: 'Convenor, Decoration Committee',
  image: "/assets/images/team/mona_sarkar.png",
  alt: 'Portrait of Monalisa Sarkar, Convenor of the Decoration Committee at HCAF'
},
{
  name: 'Arijit Sarkar',
  role: 'Convenor, Bhog & Souvenir Committee',
  image: "/assets/images/team/ajit_sarkar.png",
  alt: 'Portrait of Arijit Sarkar, Convenor of the Bhog & Souvenir Committee at HCAF'
},
{
  name: 'Nilanjana Guha Niyogi',
  role: 'Puja Committee Convenor',
  image: "/assets/images/team/nilanjana_guha.png",
  alt: 'Portrait of Nilanjana Guha Niyogi, Puja Committee Convenor at HCAF'
},
{
  name: 'Madhumita Sinha',
  role: 'Convenor, Reception Committee',
  image: "/assets/images/team/madhumita_sinha1.png",
  alt: 'Portrait of Madhumita Sinha, Convenor of the Reception Committee at HCAF'
},
{
  name: 'Sanjay Singh',
  role: 'Advisory & Sponsorship Committee',
  image: "/assets/images/team/sanjay_singh.png",
  alt: 'Portrait of Sanjay Singh, Advisory & Sponsorship Committee at HCAF'
},
{
  name: 'Arnab Mitra',
  role: 'Convenor',
  image: "/assets/images/team/arnab_mitra_colored.png",
  alt: 'Portrait of Arnab Mitra, Convenor at HCAF'
},
{
  name: 'Sandipan Ghosh',
  role: 'Sponsorship Co-Convenor',
  image: "/assets/images/team/sandipan_ghosh.png",
  alt: 'Portrait of Sandipan Ghosh, Sponsorship Co-Convenor at HCAF'
},
{
  name: 'Abhishek Pathak',
  role: 'Convenor',
  image: "/assets/images/team/abhishek_pathak.png",
  alt: 'Portrait of Abhishek Pathak, Convenor at HCAF'
}];


export default function TeamSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {entries.forEach((e) => {if (e.isIntersecting) e.target.classList.add('active');});},
      { threshold: 0.06 }
    );
    sectionRef?.current?.querySelectorAll('.reveal')?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-background w-full px-4 md:px-12 pt-12 md:pt-16 pb-12 md:pb-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12 reveal">
          <span className="inline-block px-4 py-1.5 rounded-full border border-border text-muted-foreground text-xs font-bold tracking-widest uppercase mb-4 md:mb-5">
            The Team
          </span>
          <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-black text-foreground tracking-tight">
            The Faces Behind <span className="text-primary">HCAF</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {team?.map((member, i) =>
          <div
            key={member?.name}
            className="reveal bg-card border border-border rounded-2xl md:rounded-3xl overflow-hidden hover:shadow-gold hover:-translate-y-1 transition-all duration-300 group"
            style={{ transitionDelay: `${i * 80}ms` }}>

              <div className="relative aspect-square overflow-hidden bg-muted/30">
                <AppImage
                src={member?.image}
                alt={member?.alt}
                fill
                className="object-contain"
                sizes="(max-width: 768px) 50vw, 25vw" />
              
              </div>
              <div className="p-3 md:p-5">
                <h3 className="font-display text-sm md:text-base font-black text-foreground tracking-tight">{member?.name}</h3>
                <p className="text-muted-foreground text-xs font-semibold mt-0.5">{member?.role}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}